import { isSafeUrl } from '@chatwoot/prosemirror-schema/src/rules/links';

/**
 * Resolve o que o usuario digitou no campo de link para um href utilizavel.
 *
 * O prompt do editor antigo gravava o valor cru: digitar `flipdesk.com.br`
 * produzia `href="flipdesk.com.br"`, que o navegador trata como caminho
 * relativo e leva a lugar nenhum.
 *
 * A `normalizeUrl` do pacote tambem nao resolve sozinha. Ela e construida com
 * `fuzzyLink: false`, entao devolve string vazia para dominio sem protocolo —
 * justamente o jeito mais comum de digitar um endereco. Aproveitamos dela
 * apenas a lista branca de esquemas, que e o que barra `javascript:`.
 *
 * @param {string} value texto digitado no campo
 * @returns {string} href pronto para uso, ou string vazia se invalido
 */
export function resolveHref(value = '') {
  const trimmed = value.trim();

  if (!trimmed || /\s/.test(trimmed)) {
    return '';
  }

  // Esquema conhecido (http, mailto, tel...) ou caminho relativo passa direto;
  // o resto ganha https, que e o padrao esperado ao digitar so o dominio.
  const candidate = isSafeUrl(trimmed) ? trimmed : `https://${trimmed}`;

  // Segunda checagem: se nem com o prefixo entra na lista branca, o que veio
  // era um esquema perigoso e nao deve virar link.
  if (!isSafeUrl(candidate)) {
    return '';
  }

  // Caminho relativo nao tem host para validar.
  if (candidate.startsWith('/')) {
    return candidate;
  }

  try {
    const url = new URL(candidate);

    // Só http(s) tem host; mailto e tel guardam o destino em outro lugar.
    const isWeb = url.protocol === 'http:' || url.protocol === 'https:';

    if (isWeb && !url.hostname.includes('.')) {
      return '';
    }

    return candidate;
  } catch (error) {
    return '';
  }
}

export default resolveHref;
